import { render, staticRenderFns } from "./add-prize-item.vue?vue&type=template&id=4ba2f13c&"
import script from "./add-prize-item.vue?vue&type=script&lang=js&"
export * from "./add-prize-item.vue?vue&type=script&lang=js&"
import style0 from "./add-prize-item.vue?vue&type=style&index=0&id=4ba2f13c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports